


































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ReservableCount, SearchCondition } from '@/modules/reservableCount';
import { FunctionTypes } from '@/enums/functionTypes';
import DialogWrapper from '@/components/dialogWrapper.vue';
import AvaivaledVue from '@/components/avaivaled.vue';
import moment from 'moment';
import { ElForm } from 'element-ui/types/form';

interface DateSpan {
  startDate: Date;
  endDate: Date;
}

interface ReservableCountForm {
  seq: number;
  dateSpan: DateSpan;
  count: number;
  note: string;
}

@Component({
  filters: {
    formatDate: (date: Date) => {
      return moment(date).format('YYYY年M月D日');
    }
  }
})
export default class extends AvaivaledVue {
  private get isLoading() {
    return this.$store.state.reservableCount.isLoading || this.$store.state.schedule.isLoading;
  }
  private get pageTitle() { return '予約可能コマ数設定'; }
  private get headerIcon() { return 'far fa-calendar-alt fa-2x'; }

  private get countAll() { return 0; }
  private get condition(): SearchCondition { return this.$store.state.reservableCount.searchCondition; }
  private get isMini(): boolean { return (this as any).$mq === 'mini'; }
  private get tableDatas(): ReservableCount[] { return this.$store.state.reservableCount.list; }
  private showSearchCondition = true;

  private isReservableCountEdit = true;

  private formReservableCountRule = {
    dateSpan: [
      {
        type: 'object',
        required: true,
        options: {
          first: true
        },
        fields: {
          startDate: {
            type: 'date',
            required: true,
            message: '開始日を選択してください',
          },
          endDate: {
            type: 'date',
            required: true,
            message: '終了日を選択してください',
          },
        },
      },
      {
        required: true,
        validator: (rule: any, value: DateSpan, callback: any) => {
          if (!value.startDate || !value.endDate) {
            callback(new Error('正しい期間を選択してください'));
            return;
          }

          if (value.startDate > value.endDate) {
            callback(new Error('正しい期間を選択してください'));
          } else {
            callback();
          }
        }
      },
    ],
    count: [
      {
        type: 'number',
        required: true,
        message: '予約可能コマ数を入力してください'
      },
      {
        type: 'number',
        min: 1,
        max: 99,
        message: '1以上の値を入力してください'
      },
    ],
  };

  private loadData() {
    this.$store.dispatch('reservableCount/getListRequest');
  }
  private mounted() {
    this.loadData();
  }
  private deactivated() {
    this.$destroy();
  }
  private created() {
    this.pageBackCheck(FunctionTypes.Reserve);
  }

  private onPageSizeChange(val: number) { this.condition.perPage = val; }
  private onChangePage() { this.loadData(); }
  private onChangeCondition() {
    this.condition.page = 1;
    this.loadData();
  }
  private onChangeSort( {prop, order}: any ) {
    this.condition.sort = prop ? `prop order` : '';
    this.loadData();
  }

  private submitReservableCountForm() {
    (this.$refs.reservableCountForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.reservableCountEdit as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async addReservableCount() {
    this.isReservableCountEdit = false;

    const form: ReservableCountForm = {
      seq: 0,
      dateSpan: {
        startDate: null as any,
        endDate: null as any,
      },
      count: '' as any,
      note: ''
    };

    try {
      const result = await (this.$refs.reservableCountEdit as DialogWrapper).open({...form}) as ReservableCountForm;
      const data: ReservableCount = {
        seq: result.seq,
        startDate: result.dateSpan.startDate,
        endDate: moment(moment(result.dateSpan.endDate).format('YYYY-MM-DD 23:59:59')).toDate(),
        count: result.count,
        note: result.note,
      };
      const response = await this.$store.dispatch('reservableCount/addRequest', data)
        .catch(() => { const a = 1; });
      if (response) {
        const startDate = moment(data.startDate!).format('YYYY年M月D日');
        const endDate = moment(data.endDate!).format('YYYY年M月D日');
        const name = `${startDate}～${endDate}`;
        this.$notify({
          type: 'success',
          title: '予約可能コマ数追加完了',
          message: `${name}の予約可能コマ数を追加しました。`,
          position: 'bottom-right'
        });
        this.loadData();
      }
    } catch (error) {
      return;
    }
  }

  private async editReservableCount(row: ReservableCount) {
    this.isReservableCountEdit = true;

    const form: ReservableCountForm = {
      seq: row.seq,
      dateSpan: {
        startDate: row.startDate,
        endDate: row.endDate
      },
      count: row.count,
      note: row.note,
    };

    try {
      const result = await (this.$refs.reservableCountEdit as DialogWrapper).open({...form}) as ReservableCountForm;
      const data: ReservableCount = {
        seq: result.seq,
        startDate: result.dateSpan.startDate,
        endDate: moment(moment(result.dateSpan.endDate).format('YYYY-MM-DD 23:59:59')).toDate(),
        count: result.count,
        note: result.note,
      };
      const response = await this.$store.dispatch('reservableCount/editRequest', data)
        .catch(() => { const a = 1; });
      if (response) {
        const startDate = moment(data.startDate!).format('YYYY年M月D日');
        const endDate = moment(data.endDate!).format('YYYY年M月D日');
        const name = `${startDate}～${endDate}`;
        this.$notify({
          type: 'success',
          title: '予約可能コマ数編集完了',
          message: `${name}の予約可能コマ数を変更しました。`,
          position: 'bottom-right'
        });
        this.loadData();
      }
    } catch (error) {
      return;
    }
  }

  private deleteReservableCount(row: ReservableCount) {
      const startDate = moment(row.startDate!).format('YYYY年M月D日');
      const endDate = moment(row.endDate!).format('YYYY年M月D日');
      const name = `${startDate}～${endDate}`;
      (this as any).$confirm(
        `${name}の予約可能コマ数を削除します。よろしいですか？`, {
        confirmButtonText: 'はい',
        cancelButtonText: 'いいえ',
        type: 'warning'
      })
      .then(async () => {
        const response = await this.$store.dispatch('reservableCount/removeRequest', row.seq)
          .catch(() => { const a = 1; });
        if (response) {
          this.$notify({
            type: 'success',
            title: '予約可能コマ数削除完了',
            message: `${name}の予約可能コマ数を削除しました。`,
            position: 'bottom-right'
          });
          this.loadData();
        }
      })
      .catch();
  }

  private onOutput(calendarId: number) {
    this.$store.dispatch('calendar/outputRequest', calendarId);
  }
}
